<template>
  <div class="flex items-center justify-start gap-[16px] flex-wrap py-[16px]">
    <b-button
      v-for="tab in tabs"
      :key="tab"
      :variant="activeTab === tab.toLowerCase() ? variant.active : variant.inactive"
      :disabled="disabled || (enabledTab && enabledTab !== tab.toLowerCase())"
      class="!rounded-full min-w-[180px] min-h-[40px] !py-[7px] !flex text-[#333] items-center justify-center gap-[12px] font-medium"
      @click="handleTabChange(tab)"
    >
      {{ tab }}
      <span
        v-if="(tab.toLowerCase() !== defaultTab || defaultTabHadCount) && !withoutCount"
        class="h-[24px] grid place-items-center rounded-[8px] px-[4px] text-[#333333]"
        :class="{
          'bg-[#FCD4BE]': isActiveTab(tab),
          'bg-[#E2E2E2]': !isActiveTab(tab),
        }"
      >
        {{ count[tab.toLowerCase()] || '0' }}
      </span>
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
    count: {
      type: Object,
      default: () => ({}),
    },
    withoutCount: {
      type: Boolean,
      default: false,
    },
    defaultTab: {
      type: String,
      default: 'semua',
    },
    variant: {
      type: Object,
      default: () => ({
        active: 'primary',
        inactive: 'outline-primary',
      }),
    },
    defaultTabHadCount: {
      type: Boolean,
      default: false,
    },
    enabledTab: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const { tab } = this.$route.query
    const validTabs = (this.tabs || []).map(t => t.toLowerCase())
    const initialTab = (tab && validTabs.includes(tab.toLowerCase())) ? tab : this.defaultTab
    return {
      activeTab: typeof initialTab === 'string' ? initialTab.toLowerCase() : initialTab,
    }
  },
  watch: {
    defaultTab: {
      handler(val) {
        if (val) {
          const tab = this.$route?.query?.tab
          const validTabs = (this.tabs || []).map(t => t.toLowerCase())
          if (!tab || !validTabs.includes(tab.toLowerCase())) {
            this.activeTab = val.toLowerCase()
          }
        }
      },
    },
    '$route.query.tab': {
      handler(val) {
        const validTabs = (this.tabs || []).map(t => t.toLowerCase())
        if (val && validTabs.includes(val.toLowerCase())) {
          this.activeTab = val.toLowerCase()
        } else if (this.defaultTab) {
          this.activeTab = this.defaultTab.toLowerCase()
        }
      },
    },
  },
  methods: {
    /**
     * Normalisasi label tab ke lowercase string
     * @param {string} tab
     * @returns {string}
     */
    normalizeTab(tab) {
      return typeof tab === 'string' ? tab.toLowerCase() : tab
    },
    /**
     * Ganti tab aktif, perbarui URL, dan emit ke parent
     * @param {string} tab
     * @emits tab-change
     */
    handleTabChange(tab) {
      if (this.disabled) return
      const normalizedTab = this.normalizeTab(tab)
      this.$router.replace({
        query: { ...this.$route.query, tab: normalizedTab === this.defaultTab ? undefined : normalizedTab },
      })
      this.activeTab = normalizedTab
      this.$emit('tab-change', normalizedTab)
    },
    setActiveTab(tab) {
      this.activeTab = this.normalizeTab(tab)
    },
    isActiveTab(tab) {
      return this.activeTab === this.normalizeTab(tab)
    },
  },
}
</script>
